<template>
  <section class="bg-surface-bright">
    <v-container class="py-12 py-md-16">
      <div class="text-center mb-6">
        <h2 class="text-h5 font-weight-bold mb-2">More worship app comparisons</h2>
        <p class="text-body-2 text-medium-emphasis">
          <NuxtLink to="/compare">See all Song7 comparisons →</NuxtLink>
        </p>
      </div>
      <v-row>
        <v-col v-for="related in relatedPages" :key="related.slug" cols="12" sm="6" md="4">
          <v-card :to="related.to" :disabled="related.comingSoon" class="pa-6 h-100" elevation="0" border rounded="xl">
            <v-chip v-if="related.comingSoon" size="x-small" color="grey" class="mb-2"> Coming soon </v-chip>
            <strong class="text-h6 d-block mb-2">{{ related.title }}</strong>
            <p class="text-body-2 mb-0">{{ related.summary }}</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script setup lang="ts">
// "More comparisons" block at the bottom of each /compare page: the hub link,
// then every listed comparison except the current page (see app/utils/comparePages.ts).
const props = defineProps<{
  currentSlug: string
}>()

const relatedPages = getRelatedComparePages(props.currentSlug)
</script>
